<script>
  import { createEventDispatcher, onMount } from 'svelte'
  import { _ } from 'svelte-i18n'
  import { router } from 'tinro'
  import { BASE_URL } from '../../components/DataStore'
  import * as animateScroll from 'svelte-scrollto'

  import ResultDisplay2 from './exercise/ResultDisplay2.svelte'

  import TextToSpeech2 from './exercise/TextToSpeech2.svelte'
  import Instuctions from './exercise/Instuctions.svelte'

  import UploadResult2 from './exercise/UploadResult2.svelte'
  import SpeechToTextOpus2 from './exercise/SpeechToTextOpus2.svelte'
  import {exercisePos , exerciseList} from "../../components/DataStore"

  export let textToDisplay
  export let loginDetail
  export let exerciseDetail

  const dispatch = createEventDispatcher()

  let recordingButtonState
  let errorMsg
  let retryCounter = 0
  let resultData
  let textToRead
  let submitSuccess
  let recordings = []

  let ttsWords = []
  let ssml

  let audioTag
  let timer
  let timerValue = 0
  let timerValueEnd

  let slowFlag
  let isPlaying = false

  onMount(async () => {
    textToRead = textToDisplay
    loadData()
  })

  async function loadData() {
    if (exerciseDetail?.ttsWords) {
      ttsWords = JSON.parse(exerciseDetail?.ttsWords)
    }
    if (exerciseDetail?.ttsUrl) {
      getRecording(exerciseDetail?.ttsUrl)
    }
  }

  async function getRecording(ttsUrl) {
    let filePath =
      'https://www.googleapis.com/storage/v1/b/shuoshuo/o/exerciseAudio%2F' +
      ttsUrl

    fetch(filePath)
      .then((dataResult) => {
        dataResult.json().then((dataJson) => {
          fetch(dataJson?.mediaLink).then((audioData) => {
            audioData.blob().then((audioBlob) => {
              console.log(audioBlob)
              audioTag.src = URL.createObjectURL(audioBlob)
            })
          })
        })
      })
      .catch((error) => {
        console.log('error courses', error)
      })
  }

  function timerEvent(e) {
    console.log(new Date().toISOString())
    if (timerValueEnd && timerValueEnd < timerValue + 100000) {
      pauseAudio()
      timerValue -= 1000000
    } else {
      timerValue += 1000000
    }
  }

  function startPlayButton(speed) {
    audioTag.playbackRate = speed
    slowFlag = speed === 0.5
    timerValue = 0
    timerValueEnd = undefined
    audioTag.currentTime = 0
    audioTag.play()
  }

  function startPlay() {
    clearInterval(timer)
    timer = setInterval(timerEvent, 100)
    isPlaying = true
  }

  function stopAudio() {
    clearInterval(timer)
    timerValue = 0
    timerValueEnd = undefined
    audioTag.currentTime = 0
    isPlaying = false
  }

  function pauseAudio() {
    clearInterval(timer)
    audioTag.pause()
    isPlaying = false
  }

  function playWordSound(w) {
    console.log('playWordSound', w)
    audioTag.playbackRate = 1
    timerValue = w.start
    audioTag.currentTime = w.start / 10000000
    timerValueEnd = w.end
    // audioTag.fastSeek()
    audioTag.play()
  }

  function tryAgain() {
    retryCounter++
    recordings = []

    submitSuccess = false
    resultData = undefined

    recordingButtonState = undefined
    errorMsg = undefined
  }

  function handleNewRecording(event) {
    console.log(event)
    recordings = [...recordings, event.detail]
  }

  function handleResultSubmit(event) {
    console.log('handleResultSubmit', event)
    submitSuccess = true
    resultData = event.detail?.processResultData

    animateScroll.scrollToBottom()
  }

  function handleOpenLesson(event) {
    console.log('handleOpenLesson', event)
    dispatch('openLesson', event?.detail)
  }

  function handleNextExercise(event) {
    console.log('handleNextExercise', event)
    // dispatch("nextExercise", event?.detail);
    navigateNextExercise()
  }

  function navigateNextExercise() {
    if ($exerciseList.length === ($exercisePos +1)) {
      router.goto(`lesson/${exerciseDetail?.lessonId}`)
    } else{
      let ex = $exerciseList[$exercisePos + 1];
      console.log('EX', ex);    
      router.goto(`exercise-open/${ex?.exerciseKey}`)
    }
  }
</script>

<div>
  <div class="container">
    {#if !exerciseDetail}
      {#if errorMsg}
        <div class="alert alert-danger">{errorMsg}</div>
      {:else}
        Loading ...
      {/if}
    {:else}
      <!-- <Instuctions {exerciseDetail} /> -->
        <div class="row2 mb-3">
          <div class="col2">
            <div class="instructions">{exerciseDetail.title}</div>
          </div>
        </div>
      <div class="row">
        <div class="col">
          <div class="jumbotron">
            {#if exerciseDetail.type === 'READ'}
              <div class="row2 exerciseText">
                {#each ttsWords as w, i}<span
                    class:longform={true}
                    class={w.boundaryType}
                    class:h-new={timerValue < w.start}
                    class:h-done={timerValue >= w.end}
                    class:h-current={timerValue <= w.end &&
                      w.start <= timerValue}
                    on:click={() => playWordSound(w)}>{w.displayText}</span
                  >{:else}No Data{/each}
              </div>
            {:else if exerciseDetail.type === 'READ_IMAGE'}
              <div align="center">
                <div>
                  <img
                    class="customImage"
                    src={exerciseDetail.imageUrl}
                    alt="Question"
                  />
                </div>
              </div>
              <pre class="textToRead">{exerciseDetail.question}</pre>
            {:else if exerciseDetail.type === 'MULTI_CHOICE'}
              <table class="table">
                <thead><th>Option</th><th>Text</th></thead>
                <tbody>
                  {#each exerciseDetail?.multiChoiceAnswers as mc}
                    <tr>
                      <th scope="row" />
                      <td>{mc}</td>
                    </tr>
                  {/each}
                </tbody>
              </table>
            {:else}Wrong Type
            {/if}
            <audio
              bind:this={audioTag}
              on:play={startPlay}
              on:pause={pauseAudio}
              on:ended={stopAudio}
            />
          </div>
        </div>
      </div>
      <div class="row2 playback-row">
        <div class="col2" style="padding: 0px;">
          {#if isPlaying}
            {#if slowFlag}
              <button
                id="play"
                type="button"
                class="play-icon play-asset"
                on:click={() => startPlayButton(1)}
              />
              <button
                id="playSlow"
                type="button"
                class="playSlow-icon playSlow-asset playSlow-asset-active"
                on:click={() => pauseAudio()}
              />
            {:else}
              <button
                id="play"
                type="button"
                class="play-icon play-asset play-asset-active"
                on:click={() => pauseAudio()}
              />
              <button
                id="playSlow"
                type="button"
                class="playSlow-icon playSlow-asset"
                on:click={() => startPlayButton(0.5)}
              />
            {/if}
          {:else}
            <button
              id="play"
              type="button"
              class="play-icon play-asset"
              on:click={() => startPlayButton(1)}
            />
            <button
              id="playSlow"
              type="button"
              class="playSlow-icon playSlow-asset"
              on:click={() => startPlayButton(0.5)}
            />
          {/if}
        </div>
      </div>
      <div class="row">
        <div
          class="col offset-md-0 text-center"
          style="padding-top: 8px;padding-bottom: 8px;"
        >
          {#if !submitSuccess}
            <!-- <SpeechToTextOpus
                on:message={handleNewRecording}
                bind:recordingButtonState
                timeLimit={exerciseDetail?.organizationCurrentSubscriptionLevel ===
                'TYPE_15'
                  ? 15
                  : 30}
              /> -->
            <SpeechToTextOpus2
              on:message={handleNewRecording}
              bind:recordingButtonState
              timeLimit={exerciseDetail?.organizationCurrentSubscriptionLevel ===
              'TYPE_15'
                ? 15
                : 30}
            />
            <!-- {:else}
              <i class="fas fa-microphone-alt-slash" /> -->
          {/if}
          {#if recordingButtonState === 'stop'}
            <!-- <UploadResult
                on:message={handleResultSubmit}
                on:openLesson={handleOpenLesson}
                on:tryAgainExercise={tryAgain}
                on:nextExercise={handleNextExercise}
                {loginDetail}
                {exerciseDetail}
                lastRecording={recordings.slice(-1)[0]}
              /> -->
            <UploadResult2
              on:message={handleResultSubmit}
              on:openLesson={handleOpenLesson}
              on:tryAgainExercise={tryAgain}
              on:nextExercise={handleNextExercise}
              {loginDetail}
              {exerciseDetail}
              lastRecording={recordings.slice(-1)[0]}
            />
          {/if}
        </div>
      </div>

      {#key retryCounter}
        <ResultDisplay2
          {resultData}
          lastRecording={recordings.slice(-1)[0]}
          language={exerciseDetail.courseLanguage}
          courseScoringType={exerciseDetail.courseScoringType}
          exerciseType={exerciseDetail.type}
          {exerciseDetail}
        />
      {/key}
    {/if}
  </div>
</div>

<style>
  pre {
    text-align: left;
  }

  .WordBoundary {
    margin-right: 0.5em !important;
  }

  .PunctuationBoundary {
    margin-left: -0.4em !important;
    margin-right: 0.5em !important;
  }
  .h-done {
    color: grey;
  }
  .h-new {
    color: lightgray;
  }

  .h-current {
    color: green !important;
    text-decoration: underline;
  }

  /* Play 1x speed button */
  #play {
    border: none;
    cursor: pointer;
    background-color: transparent;
    width: 26px;
    height: 26px;
    overflow: hidden;
    display: inline-block;
  }

  .play-asset {
    background-image: url("data:image/svg+xml, %3Csvg width='24' height='24' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M9.66667 17.25L16.6667 12L9.66667 6.74998V17.25ZM12 0.333313C5.56 0.333313 0.333336 5.55998 0.333336 12C0.333336 18.44 5.56 23.6666 12 23.6666C18.44 23.6666 23.6667 18.44 23.6667 12C23.6667 5.55998 18.44 0.333313 12 0.333313ZM12 21.3333C6.855 21.3333 2.66667 17.145 2.66667 12C2.66667 6.85498 6.855 2.66665 12 2.66665C17.145 2.66665 21.3333 6.85498 21.3333 12C21.3333 17.145 17.145 21.3333 12 21.3333Z' fill='%235E5E61'/%3E%3C/svg%3E%0A");
    background-size: cover;
  }

  .play-asset:hover,
  .play-asset:focus,
  .play-asset-active {
    background-image: url("data:image/svg+xml, %3Csvg width='23' height='23' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='22' height='22' rx='11' fill='%2300A094' stroke='%23028A80'/%3E%3Cpath d='M9 6V17L16 11.5L9 6Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  /* Play 0.5x speed button */
  #playSlow {
    border: none;
    cursor: pointer;
    background-color: transparent;
  }

  .playSlow-icon {
    display: inline-block;
    width: 53px;
    height: 26px;
  }

  .playSlow-asset {
    background-image: url("data:image/svg+xml, %3Csvg width='53' height='26' viewBox='0 0 53 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M25.072 17.144C24.272 17.144 23.64 16.804 23.176 16.124C22.712 15.436 22.48 14.444 22.48 13.148C22.48 11.852 22.712 10.876 23.176 10.22C23.64 9.556 24.272 9.224 25.072 9.224C25.872 9.224 26.504 9.556 26.968 10.22C27.432 10.884 27.664 11.86 27.664 13.148C27.664 14.444 27.432 15.436 26.968 16.124C26.504 16.804 25.872 17.144 25.072 17.144ZM25.072 16.064C25.256 16.064 25.424 16.016 25.576 15.92C25.736 15.816 25.872 15.648 25.984 15.416C26.096 15.184 26.184 14.884 26.248 14.516C26.312 14.148 26.344 13.692 26.344 13.148C26.344 12.612 26.312 12.164 26.248 11.804C26.184 11.436 26.096 11.14 25.984 10.916C25.872 10.692 25.736 10.536 25.576 10.448C25.424 10.352 25.256 10.304 25.072 10.304C24.888 10.304 24.716 10.352 24.556 10.448C24.404 10.536 24.272 10.692 24.16 10.916C24.048 11.14 23.96 11.436 23.896 11.804C23.832 12.164 23.8 12.612 23.8 13.148C23.8 13.692 23.832 14.148 23.896 14.516C23.96 14.884 24.048 15.184 24.16 15.416C24.272 15.648 24.404 15.816 24.556 15.92C24.716 16.016 24.888 16.064 25.072 16.064ZM29.8083 17.144C29.5523 17.144 29.3363 17.056 29.1603 16.88C28.9923 16.704 28.9083 16.48 28.9083 16.208C28.9083 15.936 28.9923 15.712 29.1603 15.536C29.3363 15.36 29.5523 15.272 29.8083 15.272C30.0643 15.272 30.2763 15.36 30.4443 15.536C30.6123 15.712 30.6963 15.936 30.6963 16.208C30.6963 16.48 30.6123 16.704 30.4443 16.88C30.2763 17.056 30.0643 17.144 29.8083 17.144ZM34.349 17.144C33.733 17.144 33.213 17.04 32.789 16.832C32.373 16.616 32.025 16.368 31.745 16.088L32.381 15.2C32.613 15.416 32.873 15.608 33.161 15.776C33.449 15.936 33.785 16.016 34.169 16.016C34.601 16.016 34.953 15.888 35.225 15.632C35.505 15.376 35.645 15.016 35.645 14.552C35.645 14.096 35.517 13.744 35.261 13.496C35.005 13.248 34.665 13.124 34.241 13.124C33.993 13.124 33.785 13.16 33.617 13.232C33.449 13.296 33.249 13.404 33.017 13.556L32.357 13.136L32.585 9.368H36.665V10.532H33.785L33.629 12.38C33.789 12.3 33.945 12.24 34.097 12.2C34.257 12.152 34.437 12.128 34.637 12.128C34.965 12.128 35.273 12.176 35.561 12.272C35.857 12.368 36.113 12.516 36.329 12.716C36.545 12.908 36.717 13.156 36.845 13.46C36.973 13.756 37.037 14.108 37.037 14.516C37.037 14.932 36.961 15.304 36.809 15.632C36.665 15.96 36.469 16.236 36.221 16.46C35.973 16.684 35.685 16.856 35.357 16.976C35.037 17.088 34.701 17.144 34.349 17.144ZM37.7774 17L39.6494 13.928L37.8974 11.108H39.3854L40.0454 12.224C40.1334 12.384 40.2214 12.552 40.3094 12.728C40.4054 12.896 40.4974 13.06 40.5854 13.22H40.6334C40.7054 13.06 40.7814 12.896 40.8614 12.728C40.9414 12.552 41.0174 12.384 41.0894 12.224L41.6534 11.108H43.0814L41.3414 14.084L43.2134 17H41.7254L41.0054 15.836C40.9094 15.66 40.8094 15.484 40.7054 15.308C40.6094 15.132 40.5094 14.96 40.4054 14.792H40.3574C40.2694 14.96 40.1814 15.132 40.0934 15.308C40.0134 15.476 39.9294 15.652 39.8414 15.836L39.2174 17H37.7774Z' fill='%235E5E61'/%3E%3Crect x='1' y='1' width='51' height='24' rx='12' stroke='%235E5E61' stroke-width='2'/%3E%3Cpath d='M12 8V19L19 13.5L12 8Z' fill='%235E5E61'/%3E%3C/svg%3E%0A");
    background-size: cover;
  }

  .playSlow-asset:hover,
  .playSlow-asset:focus,
  .playSlow-asset-active {
    background-image: url("data:image/svg+xml, %3Csvg width='53' height='26' viewBox='0 0 53 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='52' height='25' rx='12.5' fill='%2300A094' stroke='%23028A80'/%3E%3Cpath d='M25.072 17.144C24.272 17.144 23.64 16.804 23.176 16.124C22.712 15.436 22.48 14.444 22.48 13.148C22.48 11.852 22.712 10.876 23.176 10.22C23.64 9.556 24.272 9.224 25.072 9.224C25.872 9.224 26.504 9.556 26.968 10.22C27.432 10.884 27.664 11.86 27.664 13.148C27.664 14.444 27.432 15.436 26.968 16.124C26.504 16.804 25.872 17.144 25.072 17.144ZM25.072 16.064C25.256 16.064 25.424 16.016 25.576 15.92C25.736 15.816 25.872 15.648 25.984 15.416C26.096 15.184 26.184 14.884 26.248 14.516C26.312 14.148 26.344 13.692 26.344 13.148C26.344 12.612 26.312 12.164 26.248 11.804C26.184 11.436 26.096 11.14 25.984 10.916C25.872 10.692 25.736 10.536 25.576 10.448C25.424 10.352 25.256 10.304 25.072 10.304C24.888 10.304 24.716 10.352 24.556 10.448C24.404 10.536 24.272 10.692 24.16 10.916C24.048 11.14 23.96 11.436 23.896 11.804C23.832 12.164 23.8 12.612 23.8 13.148C23.8 13.692 23.832 14.148 23.896 14.516C23.96 14.884 24.048 15.184 24.16 15.416C24.272 15.648 24.404 15.816 24.556 15.92C24.716 16.016 24.888 16.064 25.072 16.064ZM29.8083 17.144C29.5523 17.144 29.3363 17.056 29.1603 16.88C28.9923 16.704 28.9083 16.48 28.9083 16.208C28.9083 15.936 28.9923 15.712 29.1603 15.536C29.3363 15.36 29.5523 15.272 29.8083 15.272C30.0643 15.272 30.2763 15.36 30.4443 15.536C30.6123 15.712 30.6963 15.936 30.6963 16.208C30.6963 16.48 30.6123 16.704 30.4443 16.88C30.2763 17.056 30.0643 17.144 29.8083 17.144ZM34.349 17.144C33.733 17.144 33.213 17.04 32.789 16.832C32.373 16.616 32.025 16.368 31.745 16.088L32.381 15.2C32.613 15.416 32.873 15.608 33.161 15.776C33.449 15.936 33.785 16.016 34.169 16.016C34.601 16.016 34.953 15.888 35.225 15.632C35.505 15.376 35.645 15.016 35.645 14.552C35.645 14.096 35.517 13.744 35.261 13.496C35.005 13.248 34.665 13.124 34.241 13.124C33.993 13.124 33.785 13.16 33.617 13.232C33.449 13.296 33.249 13.404 33.017 13.556L32.357 13.136L32.585 9.368H36.665V10.532H33.785L33.629 12.38C33.789 12.3 33.945 12.24 34.097 12.2C34.257 12.152 34.437 12.128 34.637 12.128C34.965 12.128 35.273 12.176 35.561 12.272C35.857 12.368 36.113 12.516 36.329 12.716C36.545 12.908 36.717 13.156 36.845 13.46C36.973 13.756 37.037 14.108 37.037 14.516C37.037 14.932 36.961 15.304 36.809 15.632C36.665 15.96 36.469 16.236 36.221 16.46C35.973 16.684 35.685 16.856 35.357 16.976C35.037 17.088 34.701 17.144 34.349 17.144ZM37.7774 17L39.6494 13.928L37.8974 11.108H39.3854L40.0454 12.224C40.1334 12.384 40.2214 12.552 40.3094 12.728C40.4054 12.896 40.4974 13.06 40.5854 13.22H40.6334C40.7054 13.06 40.7814 12.896 40.8614 12.728C40.9414 12.552 41.0174 12.384 41.0894 12.224L41.6534 11.108H43.0814L41.3414 14.084L43.2134 17H41.7254L41.0054 15.836C40.9094 15.66 40.8094 15.484 40.7054 15.308C40.6094 15.132 40.5094 14.96 40.4054 14.792H40.3574C40.2694 14.96 40.1814 15.132 40.0934 15.308C40.0134 15.476 39.9294 15.652 39.8414 15.836L39.2174 17H37.7774Z' fill='white'/%3E%3Cpath d='M12 8V19L19 13.5L12 8Z' fill='white'/%3E%3C/svg%3E%0A");
  }

  .exerciseText {
    margin: 4vh 6vh 4vh 6vh;
  }

  .playback-row {
    margin: 2vh 6vh 4vh 6vh;
  }

  .longform {
    float: left;

    font-family: 'Roboto Slab';
    font-style: normal;
    font-weight: 400;
    font-size: 1.3em;

    color: rgba(0, 0, 0, 0.75);

    background-image: linear-gradient(#00a094, #00a094);
    background-position: 0 90%; /* determines how far from bottom */
    background-repeat: no-repeat;
    background-size: 100% 1px; /* second value determines height of border */

    margin: 1vh 1vh 0 0;
    cursor: pointer;
  }

  .longform:hover,
  .longform:active {
    color: #00a094;
  }

  .row2 {
    display: flex;
    flex-wrap: wrap;
  }

  .col2 {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
</style>
